import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const combineClass = {
    combineClass: {
        list: config => createAPI('/combineClass/list', 'post', config),
        siteTypeOption: config => createAPI('/combineClass/siteTypeOption', 'post', config),
        majorOption: config => createAPI('/combineClass/majorOption', 'post', config),
        classOption: config => createAPI('/combineClass/classOption', 'post', config),
        courseOption: config => createAPI('/combineClass/courseOption', 'post', config),
        querySkjh2List: config => createAPI('/combineClass/querySkjh2List', 'post', config),
        querySkjh3List: config => createAPI('/combineClass/querySkjh3List', 'post', config),
        changeSkjh: config => createAPI('/combineClass/changeSkjh', 'post', config),
        editRoom: config => createAPI('/combineClass/editRoom', 'post', config),
        checkpaike: config => createAPI('/combineClass/checkpaike', 'post', config),
        deleteHB: config => createAPI('/combineClass/deleteHB', 'post', config),
    },

};


export default combineClass;



// WEBPACK FOOTER //
// ./src/api/modules/combineClass.js